<template>
  <div
    v-if="data"
    class="mission-page"
    :class="{ 'has-bet-sheet': selectedCount() > 0 }"
  >
    <header class="mission-header">
      <button
        type="button"
        class="header-btn header-back"
        @click="$router.push('/user')"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ data.title }}</h1>
      <button
        type="button"
        class="header-btn header-orders"
        @click="$router.push('/user')"
      >
        <img
          src="../images/ban6/userpic.png"
          alt=""
        >
      </button>
    </header>

    <main class="mission-content">
      <section class="round-hero">
        <div class="hero-topline">
          <div class="hero-current">
            <span class="hero-label">{{ $t('buyMission.currentPeriod') }}</span>
            <strong>{{ periodCode() }}</strong>
            <span class="hero-status">{{ $t('buyMission.tippingInProgress') }}</span>
          </div>
          <button
            type="button"
            class="hero-link"
            @click="$router.push('/order')"
          >
            {{ $t('buyMission.tipRecord') }}
            <van-icon name="arrow" />
          </button>
        </div>

        <div class="round-time">
          <van-count-down
            :time="data.time ? data.time * 1000 : 0"
            @finish="finish"
          >
            <template #default="timeData">
              {{ formatCountdown(timeData) }}
            </template>
          </van-count-down>
        </div>

        <div class="hero-bottomline">
          <div
            v-if="topHistoryItem"
            class="latest-result"
          >
            <span class="latest-code">{{ topHistoryItem.code }}</span>
            <span class="latest-round">{{ $t('buyMission.round') }}</span>
            <span
              class="hero-result-pill"
              :class="'theme-' + topHistoryItem.firstKey"
            >{{ topHistoryItem.first }}</span>
            <span
              class="hero-result-pill"
              :class="'theme-' + topHistoryItem.secondKey"
            >{{ topHistoryItem.second }}</span>
          </div>
          <span
            v-else
            class="latest-code"
          >{{ $t('buyMission.noResults') }}</span>
          <button
            type="button"
            class="hero-link hero-result-link"
            @click="toggleHistory"
          >
            {{ $t('buyMission.tipResult') }}
            <van-icon :name="historyOpen ? 'arrow-up' : 'arrow-down'" />
          </button>
        </div>
      </section>

      <section
        v-if="historyOpen"
        class="history-board"
      >
        <div
          v-for="(item, historyIndex) in historyRows"
          :key="historyIndex"
          class="history-row"
        >
          <span class="history-code">{{ item.code }}</span>
          <span
            class="result-pill"
            :class="'theme-' + item.firstKey"
          >{{ item.first }}</span>
          <span
            class="result-pill"
            :class="'theme-' + item.secondKey"
          >{{ item.second }}</span>
        </div>
      </section>

      <section
        v-else
        class="reservation-panel"
      >
        <h2>{{ $t('buyMission.selectTip') }}</h2>
        <div class="option-grid">
          <button
            v-for="option in eventOptions"
            :key="option.key"
            type="button"
            class="mission-option"
            :class="['theme-' + option.key, { checked: option.selected, 'without-image': !option.showImage }]"
            @click="toggleOption(option.key)"
          >
            <img
              v-if="option.showImage"
              class="option-image"
              :src="option.image"
              alt=""
              @error="hideOptionImage(option.key)"
            >
            <span class="option-name">{{ option.name }}</span>
            <img
              v-if="option.selected"
              class="option-check"
              src="../images/ban6/ico_yes.png"
              alt=""
            >
          </button>
        </div>
      </section>
    </main>

    <section
      v-if="!historyOpen && liveVoteDisplayList.length"
      class="live-vote-panel"
    >
      <div class="live-vote-title">
        {{ $t('pro2.livevote') }}
      </div>
      <div class="live-vote-body">
        <div class="live-vote-track">
          <div
            v-for="(item, voteIndex) in liveVoteDisplayList"
            :key="voteIndex"
            class="live-vote-row"
          >
            {{ item.message }} {{ item.code }}
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="selectedCount() > 0"
      class="bet-sheet"
    >
      <div class="bet-title">
        <span class="chosen-label">{{ $t('buyMission.chosen') }}</span>
        <div class="chosen-options">
          <span
            v-for="option in selectedOptions"
            :key="option.key"
            class="chosen-option"
          >{{ option.name }}</span>
        </div>
      </div>
      <div class="bet-form">
        <label for="mission-amount">{{ $t('buyMission.tipPoints') }}:</label>
        <input
          id="mission-amount"
          v-model.trim="num"
          type="number"
          min="1"
          step="1000"
          :placeholder="$t('pro2.enteramount')"
          class="bet-input"
        >
      </div>
      <div class="bet-summary">
        <div class="bet-total">
          {{ $t('buyMission.totalPoints') }}:
          <strong>{{ formattedSelectedMoney }}</strong>
        </div>
        <div class="bet-actions">
          <button
            type="button"
            class="bet-submit"
            :class="{ disabled: submitting }"
            :disabled="submitting"
            @click="buy"
          >
            {{ $t('buyMission.tipAction') }}
          </button>
          <button
            type="button"
            class="bet-reset"
            :disabled="submitting"
            @click="resetSelection"
          >
            {{ $t('buyMission.resetSelection') }}
          </button>
        </div>
      </div>
    </section>

    <van-overlay
      :show="show1"
      @click="show1 = false"
    >
      <div
        class="wrapper1"
        @click.stop
      >
        <div class="block">
          <van-circle
            v-model="currentRate"
            :stroke-width="60"
            rate="0"
            size="100%"
            :color="gradientColor"
            :text="$t('pro2.loading')"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import { formatAssetUrl } from "../../utils/assets";
import Vue from "vue";
import {
  Overlay,
  Circle,
  Dialog,
  CountDown,
  Icon,
  Toast
} from "vant";

Vue.use(Overlay)
  .use(Circle)
  .use(Dialog)
  .use(CountDown)
  .use(Icon)
  .use(Toast);

export default {
  name: "Buy",
  data() {
    return {
      show1: false,
      submitting: false,
      currentRate: 0,
      gradientColor: {
        "0%": "#ff7a94",
        "100%": "#ff4e70"
      },
      data: null,
      index: 0,
      acc: null,
      num: "",
      da: 0,
      xiao: 0,
      dan: 0,
      shuang: 0,
      kais: [],
      historyOpen: false,
      liveVoteList: [],
      liveVoteDisplayList: [],
      brokenOptionImages: {},
      refreshTimer: null
    };
  },
  computed: {
    historyRows() {
      return this.historyList();
    },
    topHistoryItem() {
      return this.historyRows.length ? this.historyRows[0] : null;
    },
    eventOptions() {
      var keys = ["da", "xiao", "dan", "shuang"];
      return keys.map((key) => {
        var image = this.getOptionImage(key);
        return {
          key: key,
          name: this.getOptionLabel(key),
          image: image,
          selected: Number(this[key]) === 1,
          showImage: !!image && !this.brokenOptionImages[key]
        };
      });
    },
    selectedOptions() {
      return this.eventOptions.filter((option) => option.selected);
    },
    formattedSelectedMoney() {
      return this.selectedMoney().toFixed(2);
    }
  },
  created() {
    this.$parent.footer("item", true);
  },
  mounted() {
    this.index = this.$router.history.current.params.code;
    this.start();
    this.accinfo();
    this.generateLiveVotes();
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }
  },
  methods: {
    generateLiveVotes() {
      var messages = [
        this.$t("pro2.voteMsgFirst"),
        this.$t("pro2.voteMsgSecond"),
        this.$t("pro2.voteMsgFirstDone"),
        this.$t("pro2.voteMsgSecondDone"),
        this.$t("pro2.voteMsgFirst")
      ];
      var list = [];
      for (var i = 0; i < 12; i++) {
        list.push({
          message: messages[Math.floor(Math.random() * messages.length)],
          code: this.createVoteCode(i)
        });
      }
      this.liveVoteList = list;
      this.liveVoteDisplayList = list.concat(list);
    },
    createVoteCode(index) {
      var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var first = letters[(index + Math.floor(Math.random() * letters.length)) % letters.length];
      var second = letters[Math.floor(Math.random() * letters.length)];
      var number = Math.floor(Math.random() * 9) + 1;
      return first + "****" + number + second;
    },
    periodCode() {
      return this.data && this.data.qi ? this.data.qi : "";
    },
    formatCountdown(timeData) {
      var minutes = timeData.minutes < 10 ? "0" + timeData.minutes : timeData.minutes;
      var seconds = timeData.seconds < 10 ? "0" + timeData.seconds : timeData.seconds;
      return minutes + ":" + seconds;
    },
    toggleHistory() {
      this.historyOpen = !this.historyOpen;
    },
    toggleOption(key) {
      this[key] = this[key] === 1 ? 0 : 1;
    },
    hideOptionImage(key) {
      this.$set(this.brokenOptionImages, key, true);
    },
    getOptionLabel(key) {
      var labels = {
        da: "sda",
        xiao: "sxiao",
        dan: "sdan",
        shuang: "sshuang"
      };
      var value = this.data && this.data[labels[key]];
      return value ? String(value).trim() : "—";
    },
    getOptionImage(key) {
      var images = {
        da: "p1",
        xiao: "p2",
        dan: "p3",
        shuang: "p4"
      };
      return formatAssetUrl(this.data && this.data[images[key]]);
    },
    selectedCount() {
      return Number(this.da) + Number(this.xiao) + Number(this.dan) + Number(this.shuang);
    },
    selectedMoney() {
      var money = parseFloat(this.num);
      if (isNaN(money) || money < 0) {
        money = 0;
      }
      return this.selectedCount() * money;
    },
    resetSelection() {
      if (this.submitting) {
        return;
      }
      this.da = 0;
      this.xiao = 0;
      this.dan = 0;
      this.shuang = 0;
      this.num = "";
    },
    historyList() {
      var list = [];
      var source = this.kais && this.kais.length ? this.kais : [];
      for (var i = 0; i < source.length; i++) {
        list.push(this.createHistoryRow(source[i], i));
      }
      if (!list.length) {
        var baseCode = parseInt(this.periodCode(), 10) || 202606093441;
        for (var j = 1; j <= 16; j++) {
          list.push(this.createHistoryRow({
            ino: baseCode - j,
            da: j % 3 === 0 ? 1 : 0,
            dan: j % 4 === 0 ? 1 : 0
          }, j));
        }
      }
      return list;
    },
    createHistoryRow(item, index) {
      var code = item.ino || item.qi || item.id || (parseInt(this.periodCode(), 10) - index - 1);
      var firstKey = parseInt(item.da, 10) === 1 ? "xiao" : "da";
      var secondKey = parseInt(item.dan, 10) === 1 ? "shuang" : "dan";
      return {
        code: code,
        firstKey: firstKey,
        secondKey: secondKey,
        first: this.getOptionLabel(firstKey),
        second: this.getOptionLabel(secondKey)
      };
    },
    graptime(randomInt) {
      this.currentRate += randomInt;
      if (this.currentRate < 100) {
        this.refreshTimer = setTimeout(() => {
          this.graptime(randomInt);
        }, 1000);
      } else {
        this.show1 = false;
        this.refreshTimer = null;
        this.start();
        this.accinfo();
      }
    },
    finish() {
      this.show1 = true;
      this.currentRate = 0;
      this.graptime(Math.floor(Math.random() * 20) + 10);
    },
    accinfo() {
      Fetch("/user/info").then((response) => {
        this.acc = response.data;
      });
    },
    start() {
      Fetch("/index/item_detail", {
        id: this.index
      }).then((response) => {
        this.data = response.data;
        this.kais = response.data.kais || [];
        this.brokenOptionImages = {};
      });
    },
    buy() {
      if (this.submitting) {
        return false;
      }
      var amount = this.selectedCount();
      var money = parseFloat(this.num);
      if (amount === 0) {
        this.$toast(this.$t("pro.seltype"));
        return false;
      }
      if (isNaN(money) || money < 1) {
        this.$toast(this.$t("pro.minmoney0"));
        return false;
      }
      amount = amount * money;
      if (this.acc && amount > Number(this.acc.money || 0)) {
        this.$toast(this.$t("pro.insufficient"));
        return false;
      }
      Dialog.confirm({
        title: "",
        className: "mission-confirm-dialog",
        overlayClass: "mission-confirm-overlay",
        confirmButtonText: this.$t("utils.confirm"),
        cancelButtonText: this.$t("utils.cancel"),
        message: this.$t("pro.issubmit")
      }).then(() => {
        this.submitting = true;
        Fetch("/user/item_buy", {
          id: this.data.id,
          money: this.num,
          da: this.da,
          xiao: this.xiao,
          dan: this.dan,
          shuang: this.shuang
        }).then((response) => {
          if (response.data && response.data > 0) {
            this.$router.push("/invest");
          } else {
            this.$router.push("/order");
          }
        }).catch(() => {}).then(() => {
          this.submitting = false;
        });
      }).catch(() => {});
      return true;
    }
  }
};
</script>

<style lang="less" scoped>
.mission-page {
  --page-bg: #201c1d;
  --panel-bg: #282727;
  --line: #625546;
  --text: #fff7f1;
  --muted: #c2b3aa;
  --gold: #ffd0a5;
  --pink: #ff5877;
  min-height: 100vh;
  padding-bottom: 58px;
  overflow-x: hidden;
  background: var(--page-bg);
  color: var(--text);
  box-sizing: border-box;
}

.mission-page.has-bet-sheet {
  padding-bottom: 244px;
}

.mission-header {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr) 58px;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid rgba(255, 255, 255, .5);
  background: var(--page-bg);
  box-sizing: border-box;
}

.mission-header h1 {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: var(--gold);
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--gold);
}

.header-back .van-icon {
  font-size: 20px;
}

.header-back {
  justify-content: flex-start;
  padding-left: 8px;
}

.header-orders img {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 208, 165, .8);
  border-radius: 50%;
  background: #352c28;
  object-fit: cover;
}

.mission-content {
  padding: 9px 10px 0;
}

.round-hero {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 172px;
  padding: 22px 20px 16px;
  overflow: hidden;
  border-radius: 15px 15px 0 0;
  background: #ff5877 url("../images/ban6/room_bg.gif") center / cover no-repeat;
  box-sizing: border-box;
  color: #fff;
}

.round-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, rgba(255, 82, 116, .22), rgba(255, 82, 116, .06));
  pointer-events: none;
}

.hero-topline,
.hero-bottomline,
.hero-current,
.latest-result {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}

.hero-topline,
.hero-bottomline {
  justify-content: space-between;
  gap: 12px;
}

.hero-current {
  min-width: 0;
  flex-wrap: wrap;
  gap: 0 5px;
}

.hero-label,
.hero-status,
.hero-link,
.latest-round,
.latest-code {
  font-size: 12px;
  line-height: 20px;
}

.hero-label {
  width: 100%;
  margin-bottom: 2px;
}

.hero-current strong {
  font-size: 16px;
  font-weight: 800;
  line-height: 30px;
  letter-spacing: .4px;
}

.hero-status {
  margin-top: 5px;
  font-size: 12px;
}

.hero-link {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  font-weight: 600;
}

.hero-topline .hero-link {
  transform: translateY(-10px);
}

.hero-link .van-icon {
  font-size: 14px;
}

.round-time {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  min-width: 68px;
  height: 31px;
  margin: 5px 0 8px;
  padding: 0 8px;
  border: 1px solid rgba(255, 255, 255, .9);
  border-radius: 5px;
  box-sizing: border-box;
}

.round-time /deep/ .van-count-down {
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  line-height: 29px;
}

.latest-result {
  min-width: 0;
  gap: 4px;
  overflow: hidden;
}

.latest-code,
.latest-round {
  flex: 0 0 auto;
}

.hero-result-pill {
  min-width: 0;
  max-width: 82px;
  padding: 1px 5px;
  overflow: hidden;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hero-result-link {
  font-size: 12px;
}

.reservation-panel,
.history-board,
.live-vote-panel {
  border: 1px solid var(--line);
  border-radius: 13px;
  background: linear-gradient(145deg, #292928, #242322);
  box-shadow: 0 12px 24px rgba(0, 0, 0, .2);
  box-sizing: border-box;
}

.reservation-panel {
  margin-top: 13px;
  padding: 12px 18px;
}

.reservation-panel h2 {
  position: relative;
  margin: 0 0 15px -6px;
  padding-left: 10px;
  color: var(--gold);
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
}

.reservation-panel h2::before {
  content: "";
  position: absolute;
  top: 3px;
  bottom: 3px;
  left: 0;
  width: 4px;
  background: var(--pink);
}

.option-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 16px;
}

.mission-option {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  height: 87px;
  padding: 8px 5px;
  overflow: hidden;
  border: 2px solid transparent;
  border-radius: 7px;
  box-sizing: border-box;
  color: #fff;
}

.mission-option.theme-da {
  background: #8244f4;
}

.mission-option.theme-xiao {
  background: #ee5488;
}

.mission-option.theme-dan {
  background: #2897e9;
}

.mission-option.theme-shuang {
  background: #ff786f;
}

.mission-option.checked {
  border-color: #8a765e;
  background: #252322;
}

.option-image {
  flex: 0 0 42%;
  width: 42%;
  max-width: 64px;
  height: 54px;
  margin-right: 4px;
  object-fit: contain;
}

.option-name {
  min-width: 0;
  overflow: hidden;
  color: inherit;
  font-size: 16px;
  font-weight: 800;
  line-height: 21px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-option.without-image .option-name {
  text-align: center;
}

.mission-option.checked .option-name {
  color: var(--gold);
}

.option-check {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.history-board {
  margin-top: 17px;
  overflow: hidden;
}

.history-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(72px, .65fr) minmax(72px, .75fr);
  align-items: center;
  min-height: 58px;
  padding: 8px 13px;
  column-gap: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, .12);
  box-sizing: border-box;
}

.history-row:last-child {
  border-bottom: 0;
}

.history-code {
  overflow: hidden;
  color: var(--gold);
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-pill {
  min-width: 0;
  padding: 7px 6px;
  overflow: hidden;
  border-radius: 7px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hero-result-pill.theme-da,
.result-pill.theme-da {
  background: #8244f4;
}

.hero-result-pill.theme-xiao,
.result-pill.theme-xiao {
  background: #ee5488;
}

.hero-result-pill.theme-dan,
.result-pill.theme-dan {
  background: #2897e9;
}

.hero-result-pill.theme-shuang,
.result-pill.theme-shuang {
  background: #ff786f;
}

.live-vote-panel {
  margin: 16px 10px 24px;
  overflow: hidden;
}

.live-vote-title {
  padding: 13px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, .12);
  color: var(--gold);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.live-vote-body {
  height: 500px;
  overflow: hidden;
}

.live-vote-track {
  animation: liveVoteScroll 18s linear infinite;
}

.live-vote-row {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 10px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, .08);
  box-sizing: border-box;
  color: var(--muted);
  font-size: 12px;
  line-height: 18px;
}

.live-vote-row:nth-child(even) {
  background: rgba(255, 255, 255, .035);
}

.bet-sheet {
  position: fixed;
  bottom: 52px;
  left: 50%;
  z-index: 4;
  width: 100%;
  max-width: 600px;
  padding: 15px 18px 16px;
  border-top: 1px solid var(--line);
  background: #211f1e;
  box-shadow: 0 -12px 28px rgba(0, 0, 0, .35);
  box-sizing: border-box;
  transform: translateX(-50%);
}

.bet-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  color: var(--gold);
  font-size: 13px;
  font-weight: 800;
  line-height: 20px;
}

.chosen-label {
  flex: 0 0 auto;
  padding-left: 8px;
  border-left: 3px solid var(--pink);
}

.chosen-options {
  display: flex;
  flex: 1 1 0;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.chosen-option {
  max-width: 100%;
  padding: 1px 9px;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: 12px;
  color: var(--gold);
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bet-form {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.bet-form label {
  flex: 0 0 auto;
  color: var(--muted);
  font-size: 12px;
  line-height: 20px;
}

.bet-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: 5px;
  outline: none;
  background: #2b2826;
  box-sizing: border-box;
  color: var(--gold);
  font-size: 13px;
}

.bet-input::placeholder {
  color: #968477;
}

.bet-input:focus {
  border-color: var(--gold);
}

.bet-submit {
  flex: 1 1 0;
  height: 42px;
  border: 0;
  border-radius: 5px;
  background: linear-gradient(120deg, #f5cfa8, #dbab73);
  box-shadow: 0 7px 16px rgba(0, 0, 0, .25);
  color: #5a4839;
  font-size: 14px;
  font-weight: 800;
}

.bet-submit.disabled {
  opacity: .65;
}

.bet-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
}

.bet-total {
  flex: 1 1 auto;
  min-width: 0;
  color: var(--gold);
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
}

.bet-total strong {
  margin-left: 6px;
  color: var(--pink);
  font-size: 14px;
}

.bet-actions {
  display: flex;
  flex: 0 0 168px;
  gap: 5px;
}

.bet-reset {
  width: 46px;
  height: 42px;
  border: 0;
  border-radius: 5px;
  background: #a5a5a5;
  color: #4e433a;
  font-size: 13px;
  font-weight: 600;
}

.bet-reset:disabled {
  opacity: .65;
}

.wrapper1 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.block {
  width: 120px;
  height: 120px;
}

/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, .72);
}

/deep/ .van-circle__text {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

@keyframes liveVoteScroll {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-50%);
  }
}

@media (max-width: 360px) {
  .round-hero {
    min-height: 164px;
    padding: 15px 12px 12px;
  }

  .hero-current strong {
    font-size: 20px;
  }

  .hero-status {
    font-size: 12px;
  }

  .reservation-panel {
    padding: 12px 10px;
  }

  .option-grid {
    gap: 10px;
  }

  .mission-option {
    height: 82px;
    padding: 8px 5px;
  }

  .option-image {
    flex-basis: 40%;
    width: 40%;
    height: 48px;
  }

  .option-name {
    font-size: 13px;
  }

  .history-row {
    grid-template-columns: minmax(0, 1fr) 62px 68px;
    padding: 8px;
    column-gap: 6px;
  }

  .bet-sheet {
    padding-right: 12px;
    padding-left: 12px;
  }

  .bet-actions {
    flex-basis: 142px;
  }

  .bet-reset {
    width: 38px;
  }
}
</style>

<style lang="less">
.mission-confirm-overlay {
  background: rgba(0, 0, 0, .76);
}

.mission-confirm-dialog.van-dialog {
  overflow: hidden;
  border: 1px solid #75654f;
  border-radius: 12px;
  background: linear-gradient(135deg, #2d2724, #232323);
  box-shadow: 0 18px 42px rgba(0, 0, 0, .48);
}

.mission-confirm-dialog .van-dialog__content {
  background: transparent;
}

.mission-confirm-dialog .van-dialog__message {
  padding: 28px 20px;
  color: #f4ece7;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
}

.mission-confirm-dialog .van-dialog__footer {
  border-top: 1px solid #4a4038;
}

.mission-confirm-dialog .van-dialog__cancel,
.mission-confirm-dialog .van-dialog__confirm {
  height: 46px;
  border: 0;
  font-size: 14px;
  font-weight: 700;
}

.mission-confirm-dialog .van-dialog__cancel {
  border-right: 1px solid #4a4038;
  background: #282524;
  color: #bda895;
}

.mission-confirm-dialog .van-dialog__confirm {
  background: linear-gradient(120deg, #f5cfa8, #dbab73);
  color: #5a4839;
}
</style>
